import { AddGithubInstallation } from 'components/github-installation/add';

const GithubInstallationPage = () => {
  return <AddGithubInstallation />;
};

export default GithubInstallationPage;
